import { ListItem } from '@material-ui/core';
import clsx from 'clsx';
import {
  generatePathToRedirect,
  isSubModuleVisibleToUser,
} from 'components/Sidebar/utils/SidebarRouteLinkHelper';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { UserDTO } from 'types/user';
import { WellFullDetailsDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

import styles from '../../Sidebar.module.scss';
import { isRouteActive, SidebarRoute } from '../../utils/RouteLinks';
import ListAltIcon from '@material-ui/icons/ListAlt'
import  AssesmentIcon from '@material-ui/icons/Assessment'

type SubRouteProps = {
  user: UserDTO | null;
  well?: WellFullDetailsDTO;
  wellbore?: InnerWellboreWithWellInfo;
  route: SidebarRoute;
};

const iconMap:any={
  EDDR:ListAltIcon,
  LESSONS_LEARNT:AssesmentIcon
}
const SubRouteLink: FC<SubRouteProps> = ({ well, wellbore, user, route }) => {
  const Icon = iconMap[route.module]
  return (
  <ListItem className={styles.subRouteListItems}>
    {isSubModuleVisibleToUser(user, route.module) && (
      <NavLink
        exact
        activeClassName={styles.activeLink}
        className={clsx(styles.link, styles.subRoute, route.isDisabled && styles.disableLink)}
        to={generatePathToRedirect(route.path, route.paramName, route.queryParam, well, wellbore)}
        isActive={(match, { pathname }) => isRouteActive(pathname, route)}
      >
        <div className={styles.menuContent}>
        {Icon && <Icon className={styles.sidebarIcon}/>}
        <FormattedMessage id={route.name} />
        </div>
       </NavLink>
    )}
  </ListItem>
)};

export default SubRouteLink;
